export default __webpack_public_path__ + "static/media/report_download.549416e0.svg";